export class TracingActivatedResponseModel {
    activated;
}
//# sourceMappingURL=tracing-activated-response.js.map